import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(engineerId, email) {
  return yield oncallFetch("/api/oncall/partners/engineers/emails/add", {
    engineerId,
    email,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/engineers/emails/add.js